import { HttpClient } from '@/shared/lib/http-client';

export const verifyEmail = async({ email, token }) => {
  const response = await HttpClient.get('/auth/email/verify', {
    email,
    token,
  });

  return response.data?.data;
};
